import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { PerInfoBoxInputNumberElement } from '../../../../components/custom_components/InfoBox/InfoBoxInputNumberElement'
import useCompanyRankingSettingsMutations from '../../../../graphql/company-ranking-settings/hooks/useCompanyRankingSettingsMutations'

import { CompanySettingsRankingsSettingsFormProps } from './CompanySettingsRankingsSettingsForm'
import { useCompanySettingsRankingFormControl } from './useCompanySettingsRankingFormControl'

export const CompanySettingsRankingLowTagControl: FC<CompanySettingsRankingsSettingsFormProps> = ({
  companyId,
  country,
  settings,
  disabled,
}) => {
  const { t } = useTranslation()

  const { updateLowPercentage } = useCompanyRankingSettingsMutations(companyId, country)

  const [formValue, setFormValue] = useCompanySettingsRankingFormControl<number>(settings.lowPercentage, updateLowPercentage)

  const handleChange = (val) => {
    const value = Number.parseFloat(val)
    setFormValue(!!value ? (value > 100 ? 100 : value) : 0)
  }

  return (
    <PerInfoBoxInputNumberElement
      label={t('companySettingsView.rankingTab.settings.lowPercentage')}
      type="decimalPercentage"
      min={0}
      max={100}
      step={0.1}
      width="90px"
      value={formValue || 0}
      onChange={handleChange}
      disabled={disabled}
    />
  )
}
